import React, { memo, useMemo, type PropsWithChildren } from "react";
import { createContext } from "react";

export type IConfig = {
  network: {
    cache: {
      ttlMilliseconds: number;
    };
    useMocks: boolean;
    recordingEnabled: boolean;
  };
};

export const DEFAULT_CONFIG: IConfig = {
  network: {
    cache: {
      ttlMilliseconds: 5 * 1000,
    },
    useMocks: false,
    recordingEnabled: false,
  },
};

export const ConfigContext = createContext<IConfig | undefined>(undefined);

export type ConfigProps = {
  config?: RecursivePartial<IConfig>;
};

export type ConfigValues = {
  config: IConfig;
};

const ContextProvider = ({
  config = {},
  children,
}: PropsWithChildren<ConfigProps>) => {
  const value = useMemo(
    () => Object.assign(DEFAULT_CONFIG, config),
    [config],
  ) as IConfig;
  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
};

export default memo(ContextProvider);
